import { createAction, props } from '@ngrx/store';

import { ObjectCardKind, ObjectCardType } from '@common/components/object-card';

import { MonitoringItem } from '../../app/portal/pages/monitoring-page/monitoring.types';

export const loadMonitoring = createAction('[Monitoring] Load Monitoring');

export const loadMonitoringSuccess = createAction(
  '[Monitoring] Load Monitoring Success',
  props<{ monitoring: MonitoringItem[] }>(),
);

export const loadMonitoringFailure = createAction(
  '[Monitoring] Load Monitoring Failure',
  props<{ error: string }>(),
);
// --------------- Add Monitoring ---------------

export const createMonitoringItemFromRawObject = createAction(
  '[Monitoring] Create Monitoring Item From Raw Object',
  props<{ rawObject: any }>(),
);

export const addMonitoringItem = createAction(
  '[Monitoring] Add Monitoring Item',
  props<{ item: MonitoringItem }>(),
);

export const addMonitoringItems = createAction(
  '[Monitoring] Add Monitoring Items',
  props<{ items: MonitoringItem[] }>(),
);
// ---------------------------------------------

// --------------- Update Monitoring ---------------

export const updateMonitoringFromRawObject = createAction(
  '[Monitoring] Update Monitoring From Raw Object',
  props<{ rawObject: any }>(),
);

export const updateMultipleMonitoring = createAction(
  '[Monitoring] Update Multiple Monitoring',
  props<{ updates: { id: number; changes: Partial<MonitoringItem> }[] }>(),
);

export const updateOneMonitoring = createAction(
  '[Monitoring] Update One Monitoring',
  props<{ id: number; changes: Partial<MonitoringItem> }>(),
);
// ---------------------------------------------

export const deleteMonitoringItem = createAction(
  '[Monitoring] Delete Monitoring Item',
  props<{ id: number }>(),
);

// --------------- Object cards ---------------
export const loadObjectCardData = createAction(
  '[Monitoring] Load Object Card Data',
  props<{ objectId: number; cardType: ObjectCardKind }>(),
);

export const loadObjectCardDataSuccess = createAction(
  '[Monitoring] Load Object Card Data Success',
  props<{ cardType: ObjectCardKind; objectCardInfo: ObjectCardType }>(),
);

export const loadObjectCardDataFailure = createAction(
  '[Monitoring] Load Object Card Data Failure',
  props<{ objectId: number; cardType: ObjectCardKind; error: string }>(),
);

/** Убрать загруженные данные карточки — компонент карточки уничтожен */
export const clearObjectCardData = createAction(
  '[Monitoring] Clear Object Card Data',
  props<{ objectId: number; cardType: ObjectCardKind }>(),
);

/** Перезапросить все открытые карточки — например, после смены настроек в профиле */
export const reloadOpenedObjectCards = createAction('[Monitoring] Reload Opened Object Cards');

// --------------- Fixed object cards ---------------
export const toggleFixedObjectCard = createAction(
  '[Monitoring] Toggle Fixed Object Card',
  props<{ id: number }>(),
);

export const closeFixedObjectCard = createAction(
  '[Monitoring] Close Fixed Object Card',
  props<{ id: number }>(),
);
// ---------------------------------------------

// --------------- showOnMap ---------------
export const setShowOnMap = createAction(
  '[Monitoring] Set Show On Map',
  props<{ id: number; show: boolean }>(),
);

/**
 * @example
 * store.dispatch(setMultipleShowOnMap({
 *   updates: [
 *     { id: 1, show: true },
 *     { id: 2, show: false },
 *     { id: 3, show: true },
 *   ]
 * }));
 */
export const setMultipleShowOnMap = createAction(
  '[Monitoring] Set Multiple ShowOnMap',
  props<{ updates: { id: number; show: boolean }[] }>(),
);

export const patchShowOnMap = createAction(
  '[Monitoring] Patch ShowOnMap',
  props<{ objectIds: number[]; state: boolean }>(),
);

/**
 * @example
 * store.dispatch(setAllShowOnMap({ show: true })); // Показать все
 * store.dispatch(setAllShowOnMap({ show: false })); // Скрыть все
 */
export const setAllShowOnMap = createAction(
  '[Monitoring] Set All ShowOnMap',
  props<{ show: boolean }>(),
);

export const openObjectCardOnMap = createAction(
  '[Monitoring] Open Object Card On Map',
  props<{ id: number }>(),
);

export const closeObjectCardOnMap = createAction('[Monitoring] Close Object Card On Map');

export const setTrackedObjectOnMapId = createAction(
  '[Monitoring] Set Tracked Object On Map Id',
  props<{ id: number | null }>(),
);

// ---------------------------------------------

export const normalizeMonitoringFromObjects = createAction(
  '[Monitoring] Normalize From Objects',
  props<{ ids: number[] }>(),
);

export const syncMonitoringFromSocket = createAction(
  '[Monitoring] Sync From Socket',
  props<{ newObjectsIds: number[]; removedObjectIds: number[] }>(),
);

export const batchSyncMonitoring = createAction(
  '[Monitoring] Batch Sync Monitoring',
  props<{ items: MonitoringItem[]; deleteIds: number[] }>(),
);

export const setMaxRt = createAction('[Monitoring] Set MaxRt', props<{ maxRt: number | null }>());

export const pollMonitoringSuccess = createAction(
  '[Monitoring] Poll Monitoring Success',
  props<{ maxRt: number; lastInfo: Record<string, any> }>(),
);

// export const setSearchText = createAction(
//   '[Monitoring] Set Search Text',
//   props<{ searchText: string }>(),
// );
//
// export const setSort = createAction(
//   '[Monitoring] Set Sort',
//   props<{ sortBy: keyof MonitoringItem; sortDirection: 'asc' | 'desc' }>(),
// );
